import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/nl';
import 'moment/locale/de';
import { IntlProvider, addLocaleData } from 'react-intl';
import { useQuery } from '@apollo/client';
import { GET_LOCALE } from 'store/queries';

import enLocaleData from 'react-intl/locale-data/en';
import frLocaleData from 'react-intl/locale-data/fr';
import nlLocaleData from 'react-intl/locale-data/nl';
import deLocaleData from 'react-intl/locale-data/de';
import enGB from 'translations/en-GB.json';
import frFR from 'translations/fr-FR.json';
import nlNL from 'translations/nl-NL.json';
import deDE from 'translations/de-DE.json';

addLocaleData(enLocaleData);
addLocaleData(frLocaleData);
addLocaleData(nlLocaleData);
addLocaleData(deLocaleData);

const messages = {
  'en-GB': enGB,
  'fr-FR': frFR,
  'nl-NL': nlNL,
  'de-DE': deDE
};

const Provider = ({ children }) => {
  const { data } = useQuery(GET_LOCALE);

  moment.locale(data.locale);

  return (
    <IntlProvider locale={data.locale} key={data.locale} messages={messages[data.locale]} textComponent={Fragment}>
      {children}
    </IntlProvider>
  );
};

Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
